import React from 'react';
import styles from './Footer.module.css';

interface FooterProps {
  onDataDeletionClick: () => void;
}

export function Footer({ onDataDeletionClick }: FooterProps) {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <p className={styles.brand}>Green Rituals</p>
          <p className={styles.tagline}>Grow your calm · New York</p>
        </div>
        <nav aria-label="Footer navigation">
          <ul className={styles.links}>
            <li><a href="#ako-to-funguje">How It Works</a></li>
            <li><a href="#produkt">The Kit</a></li>
            <li><a href="#recenzie">Stories</a></li>
          </ul>
        </nav>
        <div className={styles.right}>
          <p className={styles.copy}>© {new Date().getFullYear()} Green Rituals</p>
          <button
            type="button"
            className={styles.deletionLink}
            onClick={onDataDeletionClick}
          >
            Data Deletion Request
          </button>
        </div>
      </div>
    </footer>
  );
}
